
/*global window, MOVE_DATA, _satellite*/

import { trackSearch } from 'shared_critical/tracking/shared/search';

(function ($) {
  "use strict";

  var propertyStatus,
    removingKey,
    enableSchoolFlag = {
      '#searchBox': false,
      '#mortgageSearchBox': false,
      '#localSearchBox': false
    },
    validateGeoUrl;

  const AB_SRP_LAYOUT_COOKIE_LIST = 'ab-list-view';

  var formatType = {
    postal_code    : ['postal_code', 'city', 'state_code'],
    city           : ['city', 'state_code'],
    county         : ['county', 'state_code'],
    address        : ['line', 'city', 'state_code', 'postal_code'],
    neighborhood   : ['neighborhood', 'city', 'state_code'],
    street         : ['street', 'city', 'state_code'],
    recent         : ['neighborhood', 'postal_code', 'street', 'city', 'state_code', 'mlslid'],
    recent_address : ['address', 'neighborhood', 'city', 'state_code', 'postal_code'],
    school         : ['school', 'city', 'state_code'],
    building       : ['building', 'city', 'state_code'],
    school_district: ['school_district', 'city', 'state_code'],
    university     : ['university', 'city', 'state_code'],
    park           : ['park', 'city', 'state_code'],
  };

  var schoolDistrictFeatureSwitch = function() {
    return MOVE.DataStore.getData('schoolDistrictEnabled');
  }

  var isAddressSearch = function (query) {
    return query.address !== undefined;
  };

  var isSchoolSearch = function (query) {
    return query.school !== undefined;
  };

  var isSchoolDistrictSearch = function (query) {
    return query.school_district !== undefined && schoolDistrictFeatureSwitch();
  };

  var parseSearch = function (search, searchFormat) {
    return _.chain(search)
      .pick(searchFormat)
      .reject(function (str) { return !str || str.match(/^\s+$/); })
      .value()
      .join(', ');
  };

  var getRecentSearchFormat = function (formatType, search, schoolShowFlag) {
    if (isSchoolSearch(search.query) && Boolean(schoolShowFlag)) {
      return formatType.school;
    } else if (isSchoolDistrictSearch(search.query) && Boolean(schoolShowFlag)) {
      return formatType.school_district;
    } else if (search.query.university) {
      return formatType.university;
    } else if (search.query.park) {
      return formatType.park;
    } else if (isAddressSearch(search.query)) {
      return formatType.recent_address;
    } else {
      return formatType.recent;
    }
  };

  var formatRecentSearches = function (searches, schoolShowFlag) {
    return _.map(searches, function (search) {
      var recentSearchFormat = getRecentSearchFormat(formatType, search, schoolShowFlag);

      return {
        location: parseSearch(search.query, recentSearchFormat),
        areaType: search.search_type
      };
    });
  };

  var formatPlaces = function (searches) {
    return _.map(searches, function (search) {
      var areaType = search.area_type;
      return {
        location: parseSearch(search, (formatType[areaType] || [])),
        areaType,
      };
    });
  };

  var getPropertyStatus = function getPropertyStatus() {
    return propertyStatus;
  };

  var setPropertyStatus = function setPropertyStatus(newStatus) {
    newStatus      = newStatus || "for_sale";
    propertyStatus = newStatus;
  };

  var updateSearchBox = function (widgetType) {
    var searchBoxValue = MOVE.UserActivity.getSortedRecentSearches().splice(0, 1);
    var schoolEnable   = widgetType === "#searchBox" && _.contains(MOVE.CONSTANTS.ALLOWED_SCHOOL_PAGETYPE, MOVE.DataStore.getData('pageType')) ? true : false;
    // Handling LDP in controllers/property_details.js to prepopulate sooner
    if (searchBoxValue && MOVE.DataStore.getData('pageType') !== 'ldp') {
      // Override schoolenable flag for widgetType #searchBox and page is for_sale::SRP
      if (MOVE.DataStore.getData('propertyStatus') === 'for_sale' && MOVE.DataStore.getData('pageType') === 'srp') {
        schoolEnable = true;
      }
      var recentSearch = widgetType === "#mortgageSearchBox" ? MOVE.SearchHelper.getMortgageFormattedRecentSearch() : formatRecentSearches(searchBoxValue, schoolEnable);
      var formattedLocation = MOVE.SearchHelper.getVitalityFormattedRecentSearch();

      if (!_.isEmpty(recentSearch)) {
        $(widgetType).val(recentSearch[0].location);
      }
      if (widgetType === '#searchBox') {
        $('.js-vitality-location').html(formattedLocation);
      }
    }
  };

  var $searchBoxMultiGeo = $('#add-geos-searchbox'); // AB testing ;

  $.fn.autocomplete = function (options) {
    var searchBox,
      searchBoxId,
      confidenceSuggestBox,
      confidenceSuggestBoxFlag,
      searchButton,
      searchAutoComplete,
      defaultSearchResults,
      foundSearchResults,
      invalidSearch,
      geoListPos,
      isFromSRP,
      includeZip,
      pd,
      slugPrefix,
      validateSearchCriteriaCallback,
      placeholderText = "Please Enter a Location or #MLS",
      homepageHeaderBound = false,
      usingAutoComplete = false,
      usingRecentSearch = false,
      usingHighConfidenceSearch = false,
      keyPressed = false,
      userEnteredText = "",
      performGeoValidation,
      getMatchedRecentSearches,
      showHighConfidenceSuggestion,
      setCursorOnFocus,
      retainSecondaryFacets,
      isContentKeyCode;

    var getSearchBoxOmnitureName = function () {
      if (_.isEmpty(searchBox[0])) {
        return 'property';
      }
      switch (searchBox[0].id) {
        case 'mortgageSearchBox':
          return 'mortgage';
        case 'localSearchBox':
          return 'local';
        default:
          return 'property';
      }
    };

    options     = options || {};
    searchBox   = $(this);
    searchBoxId = (searchBox[0] && searchBox[0].id) ? ("#" + searchBox[0].id): null;
    confidenceSuggestBoxFlag = false;
    if ($(this).parent().find('.pre-populate-box').length !== 0) {
      confidenceSuggestBox = $(this).parent().find('.pre-populate-box');
      confidenceSuggestBoxFlag = true;
    }


    if (options.validateSearchCriteriaCallback !== undefined) {
      validateSearchCriteriaCallback = options.validateSearchCriteriaCallback;
    }

    if (options.placeholderText !== undefined) {
      placeholderText = options.placeholderText;
    }

    var showSearchSuggestions = function () {
      if (searchBox.is(":focus") || searchBox.is(":active")) {
        searchAutoComplete.slideDown("fast", function () {
          $(this).removeClass('no-show');
        });
      }
    };

    var getLastThreeMatchedRecentSearches = function (allRecentSearches, searchValue) {
      var lastThreeMatchedRecentSearches = [];
      $.each(allRecentSearches, function (index, recentSearch) {
        if (lastThreeMatchedRecentSearches.length >= 3) {
          return false;
        }
        var recentLocations = _.pluck(lastThreeMatchedRecentSearches, 'location');
        if (!_.isUndefined(searchValue) && (recentSearch.location && recentSearch.location.toLowerCase().startsWith(searchValue.toLowerCase()) &&
          recentLocations.indexOf(recentSearch.location) < 0)) {
          lastThreeMatchedRecentSearches.push(recentSearch);
        }
      });
      return lastThreeMatchedRecentSearches;
    };

    var convert_case = function (str) {
      var lower = str.toLowerCase();
      return lower.replace(/(^| )(\w)/g, function (x) {
        return x.toUpperCase();
      });
    };

    var makeRecentSuggestionHTML = function (matchedRecentSearches) {
      var elements    = $(),
       searchBoxValue = searchBox.val(),
       regEx          = new RegExp(searchBoxValue, "i"),
       replaceValue   = '<span class="font-semibold">' + convert_case(searchBoxValue) + '</span>';
       elements       = elements.add('<div class="hidden-xxs hidden-xs"><i class="ra ra-clock-o icon-space-right"></i>Recent Searches</div>');
       var ranking    = 1;
      //For recent searched overall ranking and category ranking are the same as recent searches are top of the list.
      matchedRecentSearches.forEach(function (object) {
        elements = elements.add('<li class="recent-search" data-overall-rank=' + ranking + ' data-area-type=' + object.areaType + ' data-feature-rank=' + ranking + '><a href="#">' + object.location.replace(regEx, replaceValue) + '</a></li>');
        ranking++;
      });
      return elements;
    };

    var setEnableSchoolFlag = function (widgetType) {
      if ((_.contains(MOVE.CONSTANTS.ALLOWED_SCHOOL_PAGETYPE, MOVE.DataStore.getData('pageType'))
        || MOVE.DataStore.getData('propertyStatus') === 'for_sale')
        && _.contains(['#searchBox'], widgetType)) {
        enableSchoolFlag[widgetType] = true;
      }
    };

    var getEnableSchoolFlag = function getEnableSchoolFlag(widgetType) {
      return enableSchoolFlag[widgetType];
    };

    var elementDropDown = function (autoComplete, oRank, cRank, areaType, eleText) {
      return '<li class="' + autoComplete + '" data-overall-rank=' + oRank + ' data-feature-rank=' + cRank + ' data-area-type=' + areaType + '><a href="#">' + eleText + '</a></li>'
    }

    var populateDropDown = function (autoCompleteResponses, matchedRecentSearches) {
      var elements      = $(),
        searchBoxValue  = searchBox.val();

      if (matchedRecentSearches.length > 0) {
        elements = elements.add(makeRecentSuggestionHTML(matchedRecentSearches));
        elements = elements.add('<hr class="divider">');
      }
      var remainingSearches = _.reject(autoCompleteResponses, function (a) { return _.find(matchedRecentSearches, function (m) { return m.location === a.location; }); });
      // The total number of searches which is Recent Searches + Auto Suggest is always equal to length of Auto Suggest (which is 10)
      var numberOfAutoCompleteSearchesToBeAppended = autoCompleteResponses.length - matchedRecentSearches.length;
      if (remainingSearches.length > 0) {
        var grouping = {
          total: 0,
          order: ['places', 'school', 'school_district', 'university'],
          places: {
            cls: 'autocomplete-place',
            groupText: 'Places',
            groupIcon: 'map-marker',
            buildings: [],
            items: [],
          },
          school: {
            cls: 'autocomplete-school',
            groupText: 'Schools',
            groupIcon: 'graduation-cap',
            items: [],
          },
          school_district: {
            cls: 'autocomplete-schooldistricts',
            groupText: 'School Districts',
            groupIcon: 'district-solid',
            items: [],
          },
          university: {
            cls: 'autocomplete-university',
            groupText: 'Universities',
            groupIcon: 'graduation-cap',
            items: [],
          }
        };
        var overallRank  = matchedRecentSearches.length + 1,
            categoryRank = 1;
        for (var index = 0; index < numberOfAutoCompleteSearchesToBeAppended; index++) {
          var areaType   = remainingSearches[index].areaType,
            location     = remainingSearches[index].location,
            regEx        = new RegExp(searchBoxValue, "i"), // use "ig" for case insensitive and global match (if-required)
            replaceValue = '<span class="font-semibold">' + convert_case(searchBoxValue) + '</span>',
            //conditions for New York Experience building search
            //if there is an address search that meets the below conditions for New York, then this search mimics a building search and ranks the search as a top suggestion
            nyExpConditions = location.indexOf("Apt") < 0 && location.indexOf("Unit") < 0 && location.indexOf("Ph") < 0 && (location.indexOf("New York") >= 0 || location.indexOf("NY") >= 0);

          var group = grouping[areaType] || grouping.places,
            li = elementDropDown(group.cls, overallRank, categoryRank, areaType, location.replace(regEx, replaceValue));

          group.items.push(li);
          if(group !== grouping.places) {
            grouping.total ++;
          }
          if (nyExpConditions && !grouping[areaType]) { // New York Building Search
            grouping.places.buildings.push(li);
          }
          categoryRank++;
          overallRank++;
        }
        //List of dropdown objects
        elements = elements.add(composeAutoCompleteDropdown(grouping));
      }
      return _.uniq(elements, false, "textContent");
    };

    var composeAutoCompleteDropdown = function (grouping) {
      var elements = [];

      if(!schoolDistrictFeatureSwitch()) {
        grouping.total -= grouping.school_district.items.length;
        grouping.school_district.items = [];
      }
      grouping.order.forEach((areaType) => {
        var group = grouping[areaType];
        var items = [].concat(group.items);
        if(areaType === 'places') {
          if(grouping.total) {
            items = _.first(items, 3);
          }
          if(group.buildings.length) {
            items.unshift(group.buildings[0]);
          }
        }
        if(items.length) {
          elements = elements.concat(`<div class="hidden-xxs hidden-xs"><i class="ra ra-${group.groupIcon} icon-space-right"></i>${group.groupText}</div>`).concat(items);
        }
      });

      return $(elements.map((x) => $(x)[0]));
    }

    var setRanks = function (objWithRank) {
      var featureRank = objWithRank.data("feature-rank") || '';
      var overallRank = objWithRank.data("overall-rank") || '';
      searchBox.data('feature-rank', featureRank);
      searchBox.data('overall-rank', overallRank);
    };

    var setAreaType = function (objWithAreaType) {
      var areaType = objWithAreaType.data("area-type") || '';
      areaType = (areaType == 'zip_code' || areaType == 'postal_code') ? 'zip' : areaType;
      searchBox.data('area-type', areaType);
    };

    var hideSearchSuggestions = function (ShouldloadSRPPage) {
      if (!$(this).hasClass('no-show')) {
        searchAutoComplete.slideUp("slow", function () {
          if (ShouldloadSRPPage) {
            performGeoValidation();
          }
        });
      }
    };

    var clickOnSearchSuggestionLink = function () {
      foundSearchResults.find('.list-unstyled li').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        usingAutoComplete = true;
        if ($(this).hasClass('recent-search')) {
          usingRecentSearch = true;
        }
        searchBox.val($(this).text());
        if (confidenceSuggestBoxFlag) {
          confidenceSuggestBox.val('');
        }
        setRanks($(this));
        setAreaType($(this));
        smoothAutocompleteScroll();
        hideSearchSuggestions(true);
      });
    };

    var showResultsContent = function (recentSearches, resultResponse) {
      var structuredResponse = formatPlaces(resultResponse);
      var dropDown           = populateDropDown(structuredResponse, recentSearches);
      foundSearchResults.find('.list-unstyled').html(dropDown);
      clickOnSearchSuggestionLink();
      defaultSearchResults.addClass('no-show');
      foundSearchResults.removeClass('no-show');
      invalidSearch.addClass('no-show');
      geoListPos = 0;
    };

    var showRecentSearchSuggestions = function (searchValue, isRemoveKey) {
      if(isSellSearchBox()) {return [];}
      var enableSchool          = getEnableSchoolFlag(searchBoxId);
      var matchedRecentSearches = getMatchedRecentSearches(searchValue, enableSchool);
      if (matchedRecentSearches.length > 0) {
        showSearchSuggestions();
        var recentSearchHTML = makeRecentSuggestionHTML(matchedRecentSearches);
        foundSearchResults.find('.list-unstyled').html(recentSearchHTML);
        if (confidenceSuggestBoxFlag && searchBox.val().length > 0 && !isRemoveKey) {
          showHighConfidenceSuggestion(matchedRecentSearches);
        }
        clickOnSearchSuggestionLink();
        defaultSearchResults.addClass('no-show');
        foundSearchResults.removeClass('no-show');
        invalidSearch.addClass('no-show');
        geoListPos = 0;
      } else {
        searchAutoComplete.css('display', 'none');
        $('#autocomplete').val('');
      }
    };

    getMatchedRecentSearches = function (searchValue, enableSchool) {
      if (MOVE.UserActivity === undefined) { return []; }
      var recentSearches          = MOVE.UserActivity.getSortedNonAjaxRecentSearches().splice(0, 10);
      var formattedRecentSearches = formatRecentSearches(recentSearches, enableSchool);
      var matchedRecentSearches   = getLastThreeMatchedRecentSearches(formattedRecentSearches, searchValue);
      var autocomplete_suggest = options.autocomplete_suggest;
      if (autocomplete_suggest && autocomplete_suggest.filter_recent_searches) {
        matchedRecentSearches = matchedRecentSearches.filter((item) => autocomplete_suggest.area_types.includes(item.areaType));
      }
      return _.uniq(matchedRecentSearches, 'location');
    };

    var getSearchController = function getSearchController() {
      if (isFromSRP && !_.isUndefined(MOVE.SRP)) {
        var searchCriteria = MOVE.SRP.SearchFacet.getSearchCriteria();
        return searchCriteria.search_controller;
      }
      else {
        var propertyTypes = MOVE.CONSTANTS.PROPERTY_STATUS,
          controllerTypes = MOVE.CONSTANTS.SEARCH_CONTROLLER_TYPE;

        // For Home page, we have to decide the controller type based on property status
        // selected
        switch (getPropertyStatus()) {
          case propertyTypes.forSale:
            return controllerTypes.forSale;
          case propertyTypes.forRent:
            return controllerTypes.forRent;
          case propertyTypes.recentlySold:
            return controllerTypes.recentlySold;
          case propertyTypes.propertyRecords:
            return controllerTypes.propertyRecords;
          case propertyTypes.newCommunity:
            return controllerTypes.newCommunity;
          case propertyTypes.newPlan:
            return controllerTypes.newPlan;
          case propertyTypes.foreclosure:
            return controllerTypes.foreclosure;
        }
      }
    };

    var setNoResultsFound = function (noSuggestion) {
      if (noSuggestion) {
        showSearchSuggestions();
        defaultSearchResults.addClass('no-show');
        foundSearchResults.addClass('no-show');
      }
    };

    // Check if the user has moved to suggestion box using keyboard up/down
    var interactWithSuggestion = function () {
      return $('.js-found-search-results .list-unstyled .highlight').length !== 0;
    };

    // Check if the user has moved to recent search box using keyboard up/down
    var interactWithRecentSearchSuggestion = function () {
      return $('.js-found-search-results .list-unstyled  .highlight').hasClass('recent-search');
    };

    var getFeatureType = function () {
      var featureType = 'pre-populated-default';
      if (interactWithRecentSearchSuggestion() || usingRecentSearch) {
        featureType = 'recent-search';
      } else if (interactWithSuggestion() || usingAutoComplete) {
        featureType = 'auto-suggest';
      } else if (usingHighConfidenceSearch === true) {
        featureType = 'high-confidence';
      } else if (keyPressed === true) {
        featureType = 'typed-in';
      }
      return featureType;
    };

    // To get secondary facets for already searched scenarios from below landers pages
    retainSecondaryFacets = function retainSecondaryFacets(){
      return isFromSRP || ($.inArray(MOVE.DOMHelper.detectPageType(), ["hp", "landers_sale", "landers_rental"]) != -1)
    };

    // Add custom logic for SRP here
    performGeoValidation = function (params) {
      if(isSellSearchBox()){
        return MOVE.SellSearch.performGeoValidation();
      }
      var locationName = params && params.location ? params.location : searchBox.val();
      var requestArgs = {
        location: locationName,
        prop_status: getPropertyStatus(),
        retain_secondary_facets: retainSecondaryFacets(),
        include_zip: includeZip,
        search_controller: getSearchController()
      };

      if (params && params.radius) {
        requestArgs.radius = params.radius;
      }

      if (slugPrefix !== undefined) {
        requestArgs.slug_prefix = "/" + slugPrefix;
        requestArgs.strip_all_facets = true;
      }

      if (requestArgs.location[0] === '#') {
        // $.cookie('srp.viewType', 'list', { path: '/' });
        //AB:BASE-103
        $.cookie('ab_srp_viewtype', AB_SRP_LAYOUT_COOKIE_LIST , { path: '/' });
      }

      $.ajax({
        url: validateGeoUrl || '/validate_geo',
        method: 'GET',
        dataType: 'JSON',
        data: requestArgs,
        success: function (response) {
          var callbackOptions = {},
            redirectCallback,
            searchBoxOmnitureName = getSearchBoxOmnitureName();
          if (response && response.url && response.url !== "no_match_found") {
            redirectCallback = function (newAddress, is_geo_search_box_search) {
              if (response.slug && (response.slug === 'New-York_NY' || response.slug === 'New-York-City_NY')) {
                $.cookie("manhattanRedirect", true, { path: '/' });
                newAddress = newAddress.replace(response.slug, 'Manhattan_NY');
              }
              if (newAddress !== undefined && newAddress.indexOf('/realestateandhomes-detail') >= 0 && MOVE.Helper.hasSessionStorage()) {
                window.sessionStorage.setItem("isLDPSearch", "true");
              }
              if (is_geo_search_box_search) {
                var match = "exact-match";
                if (_.isObject(response) && _.isObject(requestArgs) &&_.isObject(response.validatedLocation)) {
                  let isSchoolOrDistrict  = _.isNull(response.school) || _.isNull(response.school_district),
                      isValidatedLocation = !_.isNull(response.validatedLocation) && !_.isNull(requestArgs.location) && (response.validatedLocation.toUpperCase() !== requestArgs.location.toUpperCase());
                  if (isValidatedLocation && isSchoolOrDistrict) {
                    match = "partial-match";
                  }
                }
                MOVE_DATA.adobeDTM.searchBox = {
                  "name"           : searchBoxOmnitureName,
                  "query"          : requestArgs.location,
                  "searchType"     : _.isUndefined(searchBox.data("area-type")) ? ''   : searchBox.data("area-type"),
                  "userEnteredText": userEnteredText,
                  "overallRank"    : _.isUndefined(searchBox.data("overall-rank")) ? '': searchBox.data("overall-rank"),
                  "featureRank"    : _.isUndefined(searchBox.data("feature-rank")) ? '': searchBox.data("feature-rank"),
                  "feature"        : getFeatureType(),
                  "match"          : match
                };
                trackSearch(MOVE_DATA.adobeDTM.searchBox, MOVE_DATA.adobeDTM.pageType);
              }
              // move this method to end of redirect callback
              // as behavior of scripts after redirecting
              // is undefined
              window.location.href = newAddress;
            };
            if (options.validateSuccessCallback) {
              callbackOptions.url              = response.url;
              callbackOptions.slugPrefix       = slugPrefix;
              callbackOptions.slug             = response.slug;
              callbackOptions.location         = response.location;
              callbackOptions.zip              = response.zip;
              callbackOptions.city             = response.city;
              callbackOptions.state            = response.state_id;
              callbackOptions.school           = response.school;
              callbackOptions.school_district  = response.school_district;
              callbackOptions.redirectCallback = redirectCallback;
              options.validateSuccessCallback(callbackOptions);
            } else {
              redirectCallback(response.url, true);
            }
          } else {
            var noSuggestion = true;
            setNoResultsFound(noSuggestion);
            searchAutoComplete.slideDown("fast", function () {
              $(this).removeAttr('style');
              $(this).removeClass('no-show');
              $(this).find('.not-found-text').text(searchBox.val());
              var autoCompleteErrorMessage = $('#auto-complete-error-message');
              if (autoCompleteErrorMessage.length > 0) {
                $(this).children('.js-no-found-results').html(autoCompleteErrorMessage.html());
              } else {
                $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">We did not find listings</p>');
              }
              $(this).children('.js-no-found-results').removeClass('no-show');
            });
            searchBox.css('color', '#d92228');
            MOVE_DATA.adobeDTM.searchBox = {
              "name"           : searchBoxOmnitureName,
              "query"          : requestArgs.location,
              "searchType"     : searchBox.data('area-type'),
              "userEnteredText": userEnteredText,
              "overallRank"    : searchBox.data("overall-rank"),
              "featureRank"    : searchBox.data("feature-rank"),
              "feature"        : getFeatureType(),
              "match"          : "failure"
            };
            trackSearch(MOVE_DATA.adobeDTM.searchBox, MOVE_DATA.adobeDTM.pageType);
          }

          if (confidenceSuggestBox) {
            confidenceSuggestBox.val('');
          }

          usingAutoComplete = false;
          usingRecentSearch = false;
          usingHighConfidenceSearch = false;
          userEnteredText = '';
        }
      });
    };

    var listingDetailsOnError = function (requestArgs) {
      var supportedFields = ['status'];
      var additionalData  = { requestArgs: requestArgs, apiUrl: MOVE_DATA.suggestApiEndPoint };
      var transform = function (response) {
        return _.chain(response)
          .pick(supportedFields)
          .extend({ serviceResponse: response })
          .extend(additionalData)
          .value();
      };
      return function (response) {
        MOVE.Common.addNewRelicLog(
          'suggestApiError',
          transform(response)
        );
      };
    };

    var getListingDetails = function (searchValue, isRemoveKey) {
      if (isSellSearchBox()) {
         return getSellListingDetails(searchValue, isRemoveKey);
      }
      var suggestUrl = MOVE_DATA.suggestApiEndPoint;
      var searchText = searchBox.val(),
        requestArgs = {
          'input'    : searchText,
          'limit'    : 10,
          'lat'      : pd.latitude,
          'long'     : pd.longitude,
          'client_id': 'rdcV8',
        },
        enableSchool = getEnableSchoolFlag(searchBoxId),
        area_types = ['neighborhood', 'city', 'county', 'postal_code', 'address', 'building', 'street', 'university', 'park'];

      if(enableSchool) {
        area_types.push('school');
      }
      if(schoolDistrictFeatureSwitch()) {
        area_types.push('school_district');
      }

      requestArgs.area_types = area_types.join(',');

      if (options.autocomplete_suggest && options.autocomplete_suggest.area_types) {
        requestArgs.area_types = options.autocomplete_suggest.area_types;
      }
      var matchedRecentSearches = getMatchedRecentSearches(searchValue, enableSchool);

      $.ajax({
        url: suggestUrl,
        method: 'GET',
        dataType: 'JSON',
        // strip falsy values, such as BLANK
        data: _.pick(requestArgs, _.identity),
        matchedRecentSearches: matchedRecentSearches,
        error: listingDetailsOnError(requestArgs),
        success: function (response) {
          if (response && response.autocomplete) {
            var autocompleteResponse = response.autocomplete;
            if (autocompleteResponse.length > 0) {
              showSearchSuggestions();
              showResultsContent(matchedRecentSearches, autocompleteResponse);
              if (confidenceSuggestBoxFlag && !isRemoveKey) {
                showHighConfidenceSuggestion(matchedRecentSearches, autocompleteResponse);
              }
              if (removingKey || isRemoveKey) {
                // Clean up confidenceSuggestBox when clicking on backspace and delete. removingKey is global variable to record if removing key is pressed.
                // The reason of this line is to avoid issue of sequence of ajax success and key press.
                if (confidenceSuggestBox) {
                  confidenceSuggestBox.val('');
                }
              }
            } else {
              hideSearchSuggestions(false);
              if (confidenceSuggestBoxFlag) {
                confidenceSuggestBox.val('');
              }
            }
          }
        }
      });
    };

    var isSellSearchBox = function(){
      return searchBoxId == "#sell-search-address"
    }

    var getSellListingDetails = function (searchValue, isRemoveKey) {
      var suggestUrl = MOVE_DATA.suggestApiEndPoint;
      var searchText = searchBox.val(),
        requestArgs = {
          'input'    : searchText,
          'limit'    : 10,
          'lat'      : pd.latitude,
          'long'     : pd.longitude,
          'client_id': 'rdcV8',
          'debug': false,
          'include': 'summary'
        };
        requestArgs.area_types = 'address';
      var matchedRecentSearches = [];

      $.ajax({
        url: suggestUrl,
        method: 'GET',
        dataType: 'JSON',
        // strip falsy values, such as BLANK
        data: _.pick(requestArgs, _.identity),
        error: listingDetailsOnError(requestArgs),
        success: function (response) {
          getSellAutoCompleteData(response, matchedRecentSearches, isRemoveKey);
        }
      });
    };

    var getSellAutoCompleteData = function(response, matchedRecentSearches, isRemoveKey){
      if (response && response.autocomplete) {
        var autocompleteResponse = response.autocomplete;
        if (autocompleteResponse.length > 0) {
          $('.js-sell-address-error').addClass("hide");
          showSearchSuggestions();
          showResultsContent(matchedRecentSearches, autocompleteResponse);
          if (confidenceSuggestBoxFlag && !isRemoveKey) {
            showHighConfidenceSuggestion(matchedRecentSearches, autocompleteResponse);
          }
          if (removingKey || isRemoveKey) {
            if (confidenceSuggestBox) {
              confidenceSuggestBox.val('');
            }
          }
        } else {
          $('.js-sell-address-error').removeClass("hide");
          hideSearchSuggestions(false);
          if (confidenceSuggestBoxFlag) {
            confidenceSuggestBox.val('');
          }
        }
      }
    }

    var onFocusInSearchBox = function () {
      searchBox.focus(function () {
        $searchBoxMultiGeo.addClass('hide');
        setCursorOnFocus();
        var searchBoxValue = searchBox.val();
        if (searchBoxValue === placeholderText) {
          searchBox.val('').css('color', '');
        } else if (searchBoxValue === '') {
          showRecentSearchSuggestions(searchBoxValue);
        } else {
          searchBox.css('color', '');
        }
      });
    };

    var smoothAutocompleteScroll = function () {
      $('.js-autocomplete-dropdow').off('click.preventClose').on('click.preventClose', function(e) {
        e.stopPropagation();
      });
    };

    var getPrePopulateItem = function (recentsearch, suggestion) {
      if (recentsearch.length !== 0) {
        return recentsearch[0];
      }
      else if (suggestion.length !== 0) {
        return formatPlaces(suggestion)[0];
      }
      else {
        return '';
      }
    };

    showHighConfidenceSuggestion = function (recentsearch, suggestion) {
      suggestion          = suggestion || {};
      var suggest_keyword = getPrePopulateItem(recentsearch, suggestion);
      var highlight_word  = '';
      var input_word      = searchBox.val();

      if (confidenceSuggestBox) {
        if (suggest_keyword.location && suggest_keyword.location.toLowerCase().startsWith(input_word.toLowerCase()) &&
          suggest_keyword.location.length > input_word.length) {
          highlight_word = suggest_keyword.location.slice(input_word.length);
          confidenceSuggestBox.val(input_word + highlight_word);
          confidenceSuggestBox.data('area-type', suggest_keyword.areaType);
        }
        else {
          confidenceSuggestBox.val('');
        }
      }
    };

    setCursorOnFocus = function () {
      if (navigator.geolocation && $.Device.isMobile(navigator.userAgent)) {
        // Select searchbox text in mobile device
        searchBox.select();
      }
      else {
        // Move cursor to the end of searchbox
        searchBox.val(searchBox.val());
      }
    };

    // Currently, when the search box is empty and we click on search button, the error pop up
    // opens quickly , then closes and then opens again. This happens everytime we click on search box
    // with error message and then click on search button. The below logic checks for
    // such scenarios and closes all the suggestions/errors only when required.
    var checkIfCloseSuggestions = function (event) {
      var closeSuggestions = true;
      if (event.relatedTarget !== undefined && event.relatedTarget !== null) {
        var $target              = $(event.relatedTarget);
        var isSearchLink         = $target.is('a');
        var isSearchButton       = $target.hasClass('js-searchButton');
        var isTargetSearchButton = (isSearchButton) || (event.relatedTarget.id === 'searchBox');
        var isErrorDisplayed     = !(invalidSearch.hasClass('no-show'));
        if (isTargetSearchButton) {
          if (isErrorDisplayed) {
            closeSuggestions = false;
          }
        }
        else if (isSearchLink) {
          closeSuggestions = false;
        }
      }
      return closeSuggestions;
    };

    var onFocusOutSearchBox = function () {
      searchBox.blur(function (event) {
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
        if($searchBoxMultiGeo.length) { // for ab test
          $searchBoxMultiGeo.removeClass('hide');
          $('#clearInput').removeClass('hide');
        }
      });
    };

    var onFocusOutSearchButton = function () {
      searchButton.blur(function (event) {
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
      });
    };

    var onClickBody = function () {
      var body = $('body');
      body.on('click', function(event) {
        if (event.target == searchBox[0]){
          return;
        }
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
      });
    };

    var highlightSelectGeo = function (inc) {
      if (!foundSearchResults.hasClass("no-show")) {
        var geos = foundSearchResults.find('li');
        if (geos.length > 0) {
          geos.removeClass("highlight");
          geoListPos += inc;
          if (geoListPos < 0) {
            geoListPos = 0;
          } else if (geoListPos > geos.length) {
            geoListPos = geoListPos - 1;
          }
          var selectedGeo = $(geos[geoListPos - 1]);
          selectedGeo.addClass("highlight");
          searchBox.val(selectedGeo.find("a").text());
          setRanks(selectedGeo);
          setAreaType(selectedGeo);
        }
      }
    };

    var updateGeoEndpoint = function (callback) {
      // this method updates the endpoint
      // as the endpoint is searchbox-specific
      validateGeoUrl = searchButton.attr("path");
      callback();
      validateGeoUrl = undefined;
    };

    var performSearch = function () {
      updateGeoEndpoint(function () {
        var searchBoxLength = searchBox.val().length;
        if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
          var confidenceSuggestBoxLength = confidenceSuggestBox.val().length;
          if (confidenceSuggestBoxLength > 0) {
            searchBox.val(confidenceSuggestBox.val());
            usingHighConfidenceSearch = true;
          }
          setAreaType(confidenceSuggestBox);
        }

        if (searchBoxLength < 1) {
          if (options.emptySearchCallback) {
            options.emptySearchCallback();
          } else {
            searchBox.attr("placeholder", placeholderText);
            searchBox.addClass("input-error");
            setNoResultsFound();
          }
        } else {
          searchBox.blur();
          if (validateSearchCriteriaCallback === undefined || validateSearchCriteriaCallback()) {
            hideSearchSuggestions(false);
            performGeoValidation();
          } else {
            setNoResultsFound();
            searchBox.css('color', '#d92228');
          }
        }
      });
    };

    var listenForNoOfKeyStrokes = function () {
      searchBox.keydown(function (e) {
        if (keyPressed === false) {
          keyPressed = true;
          userEnteredText = searchBox.val();
        }
        removingKey = isRemovingKey(e.which);
        if (confidenceSuggestBoxFlag && confidenceSuggestBox && confidenceSuggestBox.val().length !== 0) {
          var searchTextLength = searchBox.val().length;
          var prePopText       = confidenceSuggestBox.val();
          var nextCharCode     = prePopText.charCodeAt(searchTextLength);
          if (e.which === 39 || e.which === 9) {
            // `TAB` and arrow right button
            if (confidenceSuggestBox.val() !== '') {
              e.preventDefault();
              searchBox.val(confidenceSuggestBox.val());
              usingHighConfidenceSearch = true;
            }
          }
          else if (e.which === 16) {
            // Disable `Shift`
            e.stopPropagation();
          }
          else if (e.which === 8 || e.which === 46) {
            // Backspace and delete keydown
            if (confidenceSuggestBoxFlag) { confidenceSuggestBox.val(''); }
            if (searchTextLength.length == 0){ searchBox.val('')}
          }
          else if (e.which === nextCharCode) {
            // case-insensitive match
            // Input box is not scrolling
            e.preventDefault();
            searchBox.val(searchBox.val() + String.fromCharCode(nextCharCode));
          }
          else if ((e.which === 188 && nextCharCode === 44) || e.which === 13 || e.which === nextCharCode - 32) {
            // Handle char-match, ',' or 'enter', do nothing
            return;
          }
          else {
            // Handle `, ` issue
            if (prePopText.charCodeAt(searchTextLength - 1) === 44 && nextCharCode === 32 && (e.which === prePopText.charCodeAt(searchTextLength + 1))) {
              e.preventDefault();
              searchBox.val(searchBox.val() + ' ' + prePopText.charAt(searchTextLength + 1));
            }
            // Typing in letters, numbers, comma, etc. But typing didn't match prepopulate content
            else if (isContentKeyCode(e.which) && e.which !== nextCharCode && e.which !== nextCharCode - 32) {
              confidenceSuggestBox.val('');
            }
          }
        }

      });
      searchBox.keyup(function (e) {
        searchBox.removeClass("input-error");
        if (e.which === 38) { //up
          highlightSelectGeo(-1);
          usingAutoComplete = true;
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) { confidenceSuggestBox.val(''); }
        }
        else if (e.which === 40) { //down
          highlightSelectGeo(1);
          usingAutoComplete = true;
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) { confidenceSuggestBox.val(''); }
        }
        else if (e.which === 13) { //enter
          e.preventDefault();
          performSearch();
          return;
        }
        else if (e.which === 27) { //ESC
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) { confidenceSuggestBox.val(''); }
        }
        else {
          var searchValue = searchBox.val();
          userEnteredText = searchValue;
          var totalCount  = searchValue.length;
          var isRemoveKey = false;
          if (isRemovingKey(e.which)) { //backspace and delete
            searchBox.css('color', '');
            isRemoveKey = true;
            if (searchValue.indexOf("Please Enter") !== -1 ) {
              searchBox.val('');
            }
          }
          if ((totalCount >= 0 && totalCount < 3) || searchValue.indexOf('#') === 0) {
            showRecentSearchSuggestions(searchValue, isRemoveKey);
          } else {
            if (searchBox[0].clientWidth == searchBox[0].scrollWidth || searchBox[0].scrollWidth == searchBox.width()) {
              getListingDetails(searchValue, isRemoveKey);
            }
            else {
              getListingDetails(searchValue, true);
            }
          }
        }
      });
    };

    isContentKeyCode = function (keycode) {
      var valid =
        (keycode > 47 && keycode < 58) || // number keys
        keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223);     // [\]' (in order)
      return valid;
    };

    var isRemovingKey = function (keycode) {
      return (keycode == 8 || keycode == 46);
    };

    var clickSearchButton = function () {
      searchButton.click(performSearch);
    };

    var detectClickOnAnywhere = function () {
      if (homepageHeaderBound === true) {
        return;
      }
      // This functionality is only for home page.
      var touchStartPos = 0;
      $('#homepage-header')
        .on('touchstart', function () {
          touchStartPos = $(window).scrollTop();
        })
        .on('touchend', function (event) {
          var distance = touchStartPos - $(window).scrollTop();
          var isSearchButton = $(event.target).hasClass('js-searchButton');
          if (!(distance > 20 || distance < -20) && !isSearchButton) {
            var insideClick = $("#" + event.target.id).parents(".home-search-wrapper").length === 1;
            if (!insideClick) {
              hideSearchSuggestions(false);
            }
          }
        });
      homepageHeaderBound = true; // flag to bind touch events once
    };

    var detectIsIpad = function () {
      if (MOVE.CONSTANTS.IS_IPAD) {
        detectClickOnAnywhere();
      }
    };

    var clearableInput = function () {
      var $searchBox = $('#searchBox');
      var $clearInput = $('#clearInput');
      // Show/hide "x" button on input change event
      $searchBox.on('input', function () {
        if ($searchBox.val()) {
          $clearInput.removeClass('hide');
        } else {
          $clearInput.addClass('hide');
        }
      }).trigger('input'); // trigger on page load to show "x" if $searchBox.val()
      // Clear input value on "x" click and hide "x" button
      $clearInput.on('click', function () {
        $('#autocomplete').val('');
        $searchBox.val('').focus();
        $clearInput.addClass('hide');
        if (!foundSearchResults.hasClass("no-show")) {
          showSearchSuggestions();
        }
      });
    };

    var init = function () {
      // For SRP, pd will be null and we need to get the value from gon variable.
      pd = options.latLongInfo || MOVE.DataStore.getData('searchLatLong') || {};
      searchButton         = searchBox.parent().find(".js-searchButton");
      searchAutoComplete   = searchBox.parent().next(".js-autocomplete-dropdow");
      foundSearchResults   = searchAutoComplete.children(".js-found-search-results");
      defaultSearchResults = searchAutoComplete.children('.js-default-search-results');
      invalidSearch        = searchAutoComplete.children('.js-no-found-results');
      isFromSRP = options.isSRP;
      includeZip = options.includeZip || false;
      if (options.validate_geo && options.validate_geo.slug_prefix) {
        slugPrefix = options.validate_geo.slug_prefix;
      }
      // Solve 'back' button
      if (confidenceSuggestBoxFlag && confidenceSuggestBox) { confidenceSuggestBox.val(''); }

      if ((_.isObject(MOVE.HOMEPAGE) && (searchBoxId === "#mortgageSearchBox" || searchBoxId === "#localSearchBox")) || !_.isObject(MOVE.HOMEPAGE)) {
        updateSearchBox(searchBoxId);
      }

      onFocusInSearchBox();
      onFocusOutSearchBox();
      onFocusOutSearchButton();
      onClickBody();
      listenForNoOfKeyStrokes();
      clickSearchButton();
      detectIsIpad();
      clearableInput();
      setEnableSchoolFlag(searchBoxId);
      smoothAutocompleteScroll();
    };

    $.fn.autocomplete.newSearch = performGeoValidation;


    init();
  };

  $.fn.autocomplete.getPropertyStatus    = getPropertyStatus;
  $.fn.autocomplete.setPropertyStatus    = setPropertyStatus;
  $.fn.autocomplete.formatRecentSearches = formatRecentSearches;
  $.fn.autocomplete.enableSchoolFlag     = enableSchoolFlag;

  $(document).ready(function () {
    if (_.isObject(MOVE.HOMEPAGE)) {
      updateSearchBox('#searchBox');
    }
  });

}($));



// WEBPACK FOOTER //
// ./shared_critical/components/jquery.move.autocomplete.js